<script>
    import SetupNotificationAlert from "./SetupNotificationAlert.svelte";
    import {_} from '../lib/i18n';

    export let analyze;
    export let analyzeInProgress;
    //$: analyzeInProgress = analyze ? !analyze.checkIsFinished() : false;

    export let path = '/instashpion';

    export let category;

    let authRequired;
    $: authRequired = (analyze ? (analyze.is_private && (!analyze.handler || analyze.is_not_friend)) : false);

    let restartRequired;
    $: restartRequired = (analyze ? analyze.needRestart : false);

    let wrongPassword;
    $: wrongPassword = (analyze ? analyze.isPasswordError : false);

    let isError = false;
    $: isError = (analyze || (analyze && analyze.is_not_friend) || (analyze && !analyze.is_not_friend) || (analyze && analyze.handler) || (analyze && !analyze.handler) || (analyze && analyze.needRestart) || (analyze && !analyze.needRestart) || (analyze && analyze.isPasswordError) || (analyze && !analyze.isPasswordError)) &&
        analyze.isError();
</script>

{#if !isError}
    {#if analyzeInProgress}
        <p class="feed-status__text">
            {@html $_('missingDataAlert.inProgressMessage')}
        </p>

        <SetupNotificationAlert {path} />
    {:else}
        <section class="feed-status" id="status-empty" style="margin-right: 0; margin-left: 0">
            {#if ['follows', 'followers', ].includes(category) && analyze.revision_id === 0}
                <p class="feed-status__text">
                    {@html $_('missingDataAlert.availableOnReanalyzeOnly')}
                </p>
            {:else}
                <img src="/spy20-lk/img/feed-status/sad-cat.svg" alt="No data..." class="feed-status__img" />

                <p class="feed-status__text">
                    {@html $_('missingDataAlert.noDataAvailableState')}
                </p>
                <p class="feed-status__text" style="margin-top: 15px">
                    {@html $_('missingDataAlert.noDataAvailableUpdate')}
                </p>
            {/if}
        </section>
    {/if}
{/if}
